import sortBy from "lodash.sortby";
import { useState } from "react";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { DisplayGroup } from "@/models/displayGroup";
import { DisplayGroupService } from "@/services/displayGroup/displayGroup.service";
import { showError, showSuccess } from "@/utils/notification";

export const useDisplayGroups = () => {
  const { sessionCurrentWorkspaceId } = useWorkspaces();

  const { data, error, isLoading, mutate } = DisplayGroupService.getDisplayGroupsByWorkspaceId(
    sessionCurrentWorkspaceId,
  );
  const [isUpdating, setIsUpdating] = useState(false);

  // 表示グループをorder昇順でソート
  const sortedDisplayGroups = data ? sortBy(data, "order") : undefined;

  const getDisplayGroup = (id: string) => sortedDisplayGroups?.find((dg: DisplayGroup) => dg.id === id);

  const updateDisplayGroup = async (displayGroup: DisplayGroup) => {
    setIsUpdating(true);
    try {
      await DisplayGroupService.update(displayGroup);
      await mutate();
      showSuccess("表示グループを更新しました");
    } catch (e) {
      console.error(e);
      showError("表示グループの更新に失敗しました");
    }
    setIsUpdating(false);
  };

  return {
    displayGroups: sortedDisplayGroups,
    error,
    isLoading,
    isUpdating,
    mutate,
    getDisplayGroup,
    updateDisplayGroup,
  };
};
